export var DefaultLocation;
(function (DefaultLocation) {
    DefaultLocation["UNKNOWN"] = "Unknown";
    DefaultLocation["USA"] = "USA";
})(DefaultLocation || (DefaultLocation = {}));
export var MapSourceType;
(function (MapSourceType) {
    MapSourceType["DRAFT_WAYPOINTS"] = "draftWaypoints";
    MapSourceType["WAYPOINT"] = "waypoint";
    MapSourceType["PLACES"] = "places";
    MapSourceType["SHIFTS"] = "shifts";
    MapSourceType["ITINERARY_INDICATED_START_POINT"] = "itineraryIndicatedStartPoint";
    MapSourceType["ITINERARY_ACTUAL_START_POINT"] = "itineraryActualStartPoint";
    MapSourceType["PATIENT"] = "patient";
    MapSourceType["PICK_DROP"] = "pickDrop";
    MapSourceType["CLINICIAN_LAST_LOCATION"] = "clinicianLastLocation";
    MapSourceType["ITINERARY_END_POINT"] = "itineraryEndPoint";
    MapSourceType["USER_PHOTO"] = "userPhoto";
})(MapSourceType || (MapSourceType = {}));
//# sourceMappingURL=location.js.map